import React, { useContext } from 'react'
import { Context } from '../../../Store'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@material-ui/core'
import { NextStepBanner } from './NextStepBanner'
import { VerifiedDocuemntIcon } from '../../../assets/icons/VerifiedDocumentIcon'
import { BOOKING_PRE_PAYMENT } from '../../../constants'
import { VerifiedCardIcon } from '../../../assets/icons/VerifiedCardIcon'
import { GirlCallingIcon } from '../../../assets/icons/GirlCallingIcon'
import { UserVerifiedIcon } from '../../../assets/icons/UserVerifiedIcon'
import { SafePaymentIcon } from '../../../assets/icons/SafePaymentIcon'

const steps = [
  {
    icon: <VerifiedDocuemntIcon fill="#0C9D9D" width="1.5737rem" height="1.9rem" />,
    title: 'banners.downloadOfficialDocument',
    style: {
      marginBottom: '1.25rem',
    },
    values: {
      prepayment: BOOKING_PRE_PAYMENT,
    },
  },
  {
    icon: <VerifiedCardIcon fill="#0C9D9D" width="1.5737rem" height="1.9rem" />,
    titleWithPrePayment: 'banners.firstMonthRentWithPrePayment',
    titleWithoutPrePayment: 'banners.firstMonthRentWithoutPrePayment',
    style: {
      marginBottom: '1.25rem',
    },
    showForPrePayment: true,
  },
  {
    icon: <GirlCallingIcon fill="#0C9D9D" width="1.5737rem" height="1.9rem" />,
    title: 'banners.creditCheckAnalysis',
    style: {
      marginBottom: '1.25rem',
    },
  },
  {
    icon: <UserVerifiedIcon fill="#0C9D9D" width="1.5737rem" height="1.9rem" />,
    title: 'banners.zappyrentCommision',
    style: {
      marginBottom: '1.25rem',
    },
  },
  {
    icon: <SafePaymentIcon fill="#0C9D9D" width="1.5737rem" height="1.9rem" />,
    title: 'banners.moneyBackGuaranteed',
    style: {
      marginBottom: '1.25rem',
    },
  },
]

export const NextSteps = () => {
  const [state] = useContext(Context)
  const { t } = useTranslation()
  const hasPrePayment = state.booking.has_pre_payment

  return (
    <Box style={{ margin: '2rem 0', width: '100%' }}>
      <Typography style={{ fontSize: '0.875rem', fontWeight: 700, color: '#000000' }}>{t('banners.nextSteps')}:</Typography>
      {steps.map((step) => {
        if (step.showForPrePayment && !hasPrePayment) {
          return <NextStepBanner title={step.titleWithoutPrePayment} icon={step.icon} style={step.style} values={step.values} />
        }
        if (step.showForPrePayment && hasPrePayment) {
          return <NextStepBanner title={step.titleWithPrePayment} icon={step.icon} style={step.style} values={step.values} />
        }
        return <NextStepBanner title={step.title} icon={step.icon} style={step.style} values={step.values} />
      })}
    </Box>
  )
}
